<div [formGroup]="triggerConfigOpcNoDataForm">

  <!--GATEWAYS-->
  <div class="form-group">
    <label for="cloudPlug" translate>Gateways for machine</label>
    <scitis-required-field-indicator></scitis-required-field-indicator>
    @if (isLoadingCloudPlugs) {
      <span class="fa-solid fa-spinner fa-spin"></span>
    }
    <ng-select [disabled]="!isAdminOrHigher"
      [items]="cloudPlugs" [ngClass]="{ 'is-invalid': submitted && formControls.cloudPlug.errors }"
      (focusout)="onFocusOut()"
      bindLabel="name" bindValue="id" formControlName="cloudPlug" id="cloudPlug"
      name="cloudPlug" placeholder="Select gateway">
    </ng-select>
    @if (submitted && formControls.cloudPlug.errors) {
      <div class="invalid-feedback">
        <span translate>Gateway selection required</span>
      </div>
    }
  </div>

  <!--SIGNAL EDGE-->
  <div class="form-group">
    <label for="signalEdge" translate>Signal edge</label>
    <input [disabled]="true" class="form-control" formControlName="signalEdge"
      id="signalEdge" name="signalEdge" type="text">
    </div>

  </div>